import { css, styled } from '@lichtblick/styled';
import { BorderRadius, Colors, Spacing } from '@lichtblick/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Column = styled.div<{ $isCraftsman: boolean }>`
  align-items: ${({ $isCraftsman }) => ($isCraftsman ? 'flex-start' : 'flex-end')};
  display: flex;
  flex-direction: column;
  gap: ${Spacing['3Xs']};
`;

export const Row = styled.div`
  align-items: center;
  color: ${Colors.black};
  display: flex;
  gap: ${Spacing.Xxs};

  > svg {
    height: 1rem;
    width: 1rem;
  }
`;

export const AuthorInfo = styled.div<{ $isCraftsman: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: ${({ $isCraftsman }) => ($isCraftsman ? 'row' : 'row-reverse')};
  gap: ${Spacing.Xs};
  ${({ $isCraftsman }) => ($isCraftsman ? 'margin-right: auto;' : 'margin-left: auto;')}
`;

export const DateAndTeam = styled.div`
  display: flex;
  gap: 0.75rem;
`;

export const Message = styled.div<{ $isCraftsman: boolean }>`
  ${({ $isCraftsman }) =>
    $isCraftsman
      ? css`
          margin-left: 3.5rem;
        `
      : css`
          margin-right: 3.5rem;
        `}
  background-color: ${({ $isCraftsman }) => ($isCraftsman ? Colors.white : Colors.blue[5])};
  border: 1px solid ${Colors.blue[20]};
  border-radius: ${BorderRadius.S};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S};
  margin-top: ${Spacing.Xs};
  padding: ${Spacing.S};
`;

export const MultipleChoiceItem = styled.div<{ $isYesAnswer: boolean }>`
  align-items: center;
  display: flex;
  gap: ${Spacing.Xs};
  margin-top: ${Spacing.Xs};

  > div {
    align-items: center;
    background-color: ${({ $isYesAnswer }) => ($isYesAnswer ? Colors.green[100] : Colors.gray[20])};
    border-radius: ${BorderRadius.Full};
    display: flex;
    height: 2rem;
    justify-content: center;
    width: 2rem;
    > svg {
      color: ${Colors.white};
    }
  }
`;

export const ImageContainer = styled.div`
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: ${Spacing.Xs};
  width: 100%;

  > * {
    flex: 0 0 auto;
    height: auto;
    max-width: 360px;
    min-width: 200px;
    width: auto;

    @media (max-width: 900px) {
      min-width: 180px;
    }

    @media (max-width: 600px) {
      max-width: 100%;
      min-width: 150px;
    }
  }
`;

export const ImageRow = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.S};
  max-width: 100%;
  overflow-x: auto;
  padding-bottom: 2px;
  width: 100%;

  > span {
    max-width: 100%;
    min-width: 0;
    width: auto;
  }
`;

export const ImageWithCheckbox = styled.div<{ $isLatestMessage: boolean; $isSelected: boolean }>`
  border: 3px solid
    ${({ $isLatestMessage, $isSelected }) => {
      if (!$isLatestMessage) {
        return 'transparent';
      }

      return $isSelected ? Colors.green[100] : Colors.red[100];
    }};
  border-radius: ${BorderRadius.S};
  display: inline-block;
  position: relative;
  transition: border-color 0.2s ease-in-out;
`;

export const CheckboxContainer = styled.div`
  left: ${Spacing.Xs};
  position: absolute;
  top: ${Spacing.Xs};
  z-index: 10;
`;

export const SelectAllButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: ${Spacing.Xs};
  width: 100%;
`;
